import { createContext, useContext } from 'react';

const LayoutViewportContext = createContext({ isMobile: false });

export function LayoutViewportProvider({ value, children }) {
  return (
    <LayoutViewportContext.Provider value={value}>
      {children}
    </LayoutViewportContext.Provider>
  );
}

export function useLayoutViewport() {
  return useContext(LayoutViewportContext);
}

export default LayoutViewportContext;
